import { createContext, FC, useState } from 'react';

import { AuthResultData } from '../type';

const emptyFunc = () => {};

type UserContextState = {
  authData?: AuthResultData;
  isLoading: boolean;
  isWalletConnectOpened: boolean;
  loggedIn: boolean;
  setAuthData: (value?: AuthResultData) => void;
  setIsLoading: (value: boolean) => void;
  setIsWalletConnectOpened: (value: boolean) => void;
  setLoggedIn: (value: boolean) => void;
};

export const UserContext = createContext<UserContextState>({
  authData: undefined,
  isLoading: false,
  isWalletConnectOpened: false,
  loggedIn: false,
  setAuthData: emptyFunc,
  setIsLoading: emptyFunc,
  setIsWalletConnectOpened: emptyFunc,
  setLoggedIn: emptyFunc,
});

export const UserContextProvider: FC = ({ children }) => {
  const [authData, setAuthData] = useState<AuthResultData | undefined>(
    undefined
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const [isWalletConnectOpened, setIsWalletConnectOpened] =
    useState<boolean>(false);

  return (
    <UserContext.Provider
      value={{
        authData,
        isLoading,
        isWalletConnectOpened,
        loggedIn,
        setAuthData,
        setIsLoading,
        setIsWalletConnectOpened,
        setLoggedIn,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
